import store from '../../store/store';
import { ConfigModule } from '/@/store/enums';

const ApiRequestInterceptor = (config: any) => {
	store.commit(ConfigModule.SET_LOADING, true);

	if (localStorage.getItem('language') !== null) {
		config.headers['Content-Language'] = (localStorage as any).getItem('language').toLowerCase();
	}

	return config;
};

export default ApiRequestInterceptor;
